import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorService } from "src/app/error.service";
import { ColumnChangeBO } from "../list/list.model";
import { DataStateChangeEventArgs } from "@syncfusion/ej2-angular-grids";

@Injectable({
  providedIn: 'root'
})

export class SDPService extends Subject<DataStateChangeEventArgs> {
  constructor(private http: HttpClient, public errorService: ErrorService) { super(); }
  

 
    public outputValues1(url, List, responseData, params): void {
            this.GetCallForGridTable1(url, List, responseData, params).subscribe((x) => super.next(x)
            );
        }
        //.............................GetCallForGridTable........................................
        GetCallForGridTable1(url, List, responseData, params): Observable<DataStateChangeEventArgs> {
            return this.http.post<any>(url + params, List)
                .pipe(map(
                    (response: any) =>
                        <any>{
                            result: response[responseData.result],
                            count: response[responseData.count],
                            sumOfTotalHours: response[responseData.sumOfTotalHours]
                        })).pipe(map((e: any) => {
                            e.result?.forEach(element => {
                                element.isMNChoiceAssessment=(element.isMNChoiceAssessment==true)?"Yes":"No";
                            })
                            return e;
                        }))
        }

}



